import HomePage from '@/features/home/presentation/page/HomePage';
import NewHomePage from '@/features/newHome/presentation/page/NewHomePage';
import { useAppSelector } from '@/app/store/store';

export default function ConditionalHomePage() {
  const variant = useAppSelector((s) => s.homeVariant.variant);
  return (variant === 'V2' || variant === 'V3' || variant === 'V4' || variant === 'V5' || variant === 'V6') ? <NewHomePage /> : <HomePage />;
}
